import { createFileRoute, redirect } from '@tanstack/react-router';
import { JoinRequestsTab } from '@/app/(client)/company-settings/-components/joinRequests/JoinRequestsTab';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute(
  '/(client)/company-settings/(pages)/join-requests',
)({
  beforeLoad: async () => {
    // Reviewing join requests is team-management territory, same as inviting
    // a colleague — gated on `user:create` rather than a single-role check
    // (see route.tsx's tab gating, which this mirrors), so a company-creator
    // can reach this route too, not just company-admin. Anyone else who hits
    // this URL directly is redirected away.
    const permissions = await ensurePermissions();
    if (!permissions.user.canCreate) {
      throw redirect({ to: '/company-settings/users' });
    }
  },
  component: JoinRequestsRoute,
});

function JoinRequestsRoute() {
  return <JoinRequestsTab />;
}
